module.exports = __webpack_public_path__ + "img/no-hay-documentos.dc801566.png";